// Reader display prefs: text size (--reader-scale) + translation visibility, persisted
// in Prefs so the study choice survives reloads. The in-memory current values are
// hydrated at boot (app.ts) before the network-bound reader mounts, then read
// synchronously by the reader controls - like theme/sourceLang, a lost boot race only
// means one render at the default, self-correcting on the next interaction.

import { updatePrefs } from "./store.ts";

export const MIN_SCALE = 0.85;
export const MAX_SCALE = 1.45;

let textScale = 1;
let showTranslation = true;

function clampScale(n: number): number {
  if (!Number.isFinite(n)) return 1;
  return Math.min(MAX_SCALE, Math.max(MIN_SCALE, n));
}

export function getTextScale(): number {
  return textScale;
}

export function getTranslationShown(): boolean {
  return showTranslation;
}

// Seed the in-memory values from persisted prefs at boot.
export function hydrateReaderDisplay(scale: number, shown: boolean): void {
  textScale = clampScale(scale);
  showTranslation = shown;
}

export async function persistTextScale(scale: number): Promise<void> {
  textScale = clampScale(scale);
  try {
    await updatePrefs({ textScale });
  } catch {
    /* ignore persistence failure - still applied this session */
  }
}

export async function persistTranslationShown(shown: boolean): Promise<void> {
  showTranslation = shown;
  try {
    await updatePrefs({ showTranslation });
  } catch {
    /* ignore persistence failure - still applied this session */
  }
}

// Test hook: restore module defaults between tests.
export function _resetReaderDisplayForTests(): void {
  textScale = 1;
  showTranslation = true;
}
